import { theme } from '@remote-com/norma/foundations';
import { rgba } from 'polished';
import { breakpointUntil, breakpointFrom } from 'remote-com-shared/style/mediaQueries';

export const sharedShadowDown = `0 4px 12px ${rgba(theme.colors.darkBlue, 0.05)}`;
export const sharedShadowUp = `0 -4px 12px ${rgba(theme.colors.darkBlue, 0.05)}`;

export const fromBreakpointReference = breakpointFrom.ml;
export const untilBreakpointReference = breakpointUntil.ml;
